
import Vue, {PropOptions} from 'vue'
import {ExperienceInterface} from "~/store/experience";
import {formatAddressInput} from "~/util/format-filter-data";

export default Vue.extend({
  name: 'experience',
  props: {
    experience: {
      type: Object,
      required: true
    } as PropOptions<ExperienceInterface>
  },
  computed: {
    formatAddress() {
      return formatAddressInput(this.experience.address)
    }
  }
})
